/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBenefitPeriodMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateBenefitPeriodInput;
}>;


export type UpdateBenefitPeriodMutation = { __typename?: 'Mutation', updateBenefitPeriod: { __typename?: 'BenefitPeriod', id: string, benefitPeriod: SchemaTypes.BenefitPeriodLength } | null };


export const UpdateBenefitPeriodDocument = gql`
    mutation UpdateBenefitPeriod($input: UpdateBenefitPeriodInput!) {
  updateBenefitPeriod(input: $input) {
    id
    benefitPeriod
  }
}
    `;
export type UpdateBenefitPeriodMutationFn = Apollo.MutationFunction<UpdateBenefitPeriodMutation, UpdateBenefitPeriodMutationVariables>;
export function useUpdateBenefitPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBenefitPeriodMutation, UpdateBenefitPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBenefitPeriodMutation, UpdateBenefitPeriodMutationVariables>(UpdateBenefitPeriodDocument, options);
      }
export type UpdateBenefitPeriodMutationHookResult = ReturnType<typeof useUpdateBenefitPeriodMutation>;
export type UpdateBenefitPeriodMutationResult = Apollo.MutationResult<UpdateBenefitPeriodMutation>;
export type UpdateBenefitPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateBenefitPeriodMutation, UpdateBenefitPeriodMutationVariables>;